export function formatStatusText(value) {
  if (!value || typeof value !== "string") {
    return value;
  }

  const normalized = value.replace(/\s+/g, " ").trim();
  if (normalized.length === 0) {
    return value;
  }

  return normalized
    .toLowerCase()
    .split(/[_\s]+/)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
